//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import draggable from 'vuedraggable'
import { AXIOS, axiosPost } from '../../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { EventBus } from '../../../../EventBus/EventBus.js'
import { downloadFile } from '../../../../components/helpers.js'

import { convertEmployeesFromServerToMap, convertEmployeesFromMapToArray, MONTHS, OFFSET_MSK_MS } from './CalendarUtils.js'
import { calendarSearchParams } from './calendar.js'
import EditSchedule from './EditSchedule.vue'
import CalendarScheduleWorkerRow from './CalendarScheduleWorkerRow.vue'
import CalendarScheduleSubtitleRow from './CalendarScheduleSubtitleRow.vue'
import ServerFilter from '../../../../components/ServerFilter/ServerFilter.vue'

export default {
  components: {
    EditSchedule,
    ServerFilter,
    CalendarScheduleWorkerRow,
    CalendarScheduleSubtitleRow,
    draggable
  },
  mixins: [calendarSearchParams],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      loadingFile: false,
      splitterVerticalModel: 80,

      openedEditSchedule: false,

      employeesMap: new Map(),
      employeesFromServer: [],
      rows: [],
      workDays: [],
      commonStatistics: null,
      overtimeTariffs: [],
      additionalOvertimeTariffs: [],
      overtimesGroupByValue: [],

      moveElementMinIndex: null,
      moveElementMaxIndex: null,
      orderInGroupDefault: [],

      selectedWorker: null,
      selectedDay: null,

      selectedDays: [],
      selectedRows: [],

      showBrigades: true,
      showOvertimeTariffs: true,

      scheduleForEdit: [],
      scheduleOfWorker: [],

      selectMonth: null,

      selectYear: null,
      years: [],

      editMode: false,

      sortOrderParams: {
        order: true, // по дефолту будет сортироваться по order
        shortFIO: null,
        brigade: null,
        fixedBrigade: null
      },

      tab: null,
      lastSelectedTab: null,
      neighboringMonths: false,

      roles: [
        {
          label: 'В полях',
          key: 'brigadeemployee',
          active: false
        },
        {
          label: 'Офис',
          key: 'office',
          active: false
        }
      ],

      currentEmployeeIds: [],

      keyupHandler: null,
      deactivated: false,
      workdayRequestId: 0,
      workdayTimeoutReached: false,
      workdaySearchCompleted: false
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts',
      selectedWorkAreas: 'getSelectedWorkAreas',
      user: 'getUser',
      workAreas: 'getWorkAreas',
      getBrigade: 'getBrigade',
      customWorkShiftColor: 'getCustomWorkShiftColor',
      customWorkShiftFontColor: 'getCustomWorkShiftFontColor'
    }),
    workShiftsWithCustom: function () {
      return [
        {
          name: 'Своя смена',
          key: 'brigadier.custom',
          startHour: 8,
          endHour: 17,
          color: this.customWorkShiftColor,
          fontColor: this.customWorkShiftFontColor
        },
        ...this.getWorkShifts
      ]
    },
    roleAdmin: function () {
      const roles = this.user.roles || {}
      return !!roles.root || !!roles.admin
    },
    hideOtherWorkAreaOvertimes: function () {
      const role = this.user.role || null
      return role === 'brigadier' || role === 'brigademember'
    },
    userId: function () {
      return this.user && this.user.employee ? this.user.employee.id : null
    },
    currentDayIndex: function () {
      let currentDayIndex = null
      if (this.selectMonth && this.selectMonth !== MONTHS[new Date().getMonth()]) {
        currentDayIndex = null
      } else {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        currentDayIndex = this.workDays.findIndex(day => day.date === today.getTime())
      }
      return currentDayIndex
    },
    optionsMonths: function () {
      return MONTHS
    },
    showNoEmployeesMessage: function () {
      return this.workdaySearchCompleted && !this.loading && !this.showTimeoutMessage && !(this.workDays && this.workDays.length && this.rows && this.rows.length)
    },
    showTimeoutMessage: function () {
      return this.workdayTimeoutReached
    }
  },
  watch: {
    tab: function () {
      this.updateData()
    },
    showBrigades: function () {
      localStorage.setItem('showBrigades', this.showBrigades)
    },
    selectMonth: function (value, prevValue) {
      if (prevValue) {
        this.updateData(true)
      }
    },
    selectYear: function (value, prevValue) {
      if (prevValue) {
        this.updateData(true)
      }
    },
    neighboringMonths: function () {
      this.updateData()
    },
    employeesMap: {
      handler: function () {
        this.rerenderRows()
      },
      immediate: true
    }
  },
  created: function () {
    this.keyupHandler = (event) => {
      // If 'ctrl' or 'command' was unpressed
      if ((event.key == 'Control' || event.key == 'Meta') && this.scheduleForEdit.length != 0) {
        this.endSetDays()
      }
      if (event.key == 'Escape') {
        this.selectedRows = []
      }
    }
    window.addEventListener('keyup', this.keyupHandler)

    EventBus.$on('update-workday', this.updateData)

    // TO-DO: реализовать получение доступных лет через сервер
    for (let i = 0; i < 10; i++) {
      this.years.push(2019 + i)
    }

    const today = new Date()

    this.selectMonth = MONTHS[today.getMonth()]
    this.selectYear = today.getFullYear()

    window.addEventListener('resize', this.onWindowResize)

    if (this.isMobile) {
      this.showBrigades = false
      this.onHideFilter()
    } else {
      const showBrigadesStr = localStorage.getItem('showBrigades')
      if (showBrigadesStr != null) {
        this.showBrigades = (showBrigadesStr === 'true')
      }
    }

    const selectedRoles = localStorage.getItem('calendarSelectedRoles')
    if (selectedRoles !== null) {
      this.roles.forEach((layer) => {
        if (selectedRoles.includes(layer.key)) {
          layer.active = true
        }
      })
    } else {
      const selectedRoles = []
      this.roles.forEach((role) => {
        role.active = true
        selectedRoles.push(role.key)
      })
      localStorage.setItem('calendarSelectedRoles', selectedRoles)
    }

    this.updateData(true)
  },
  activated: function () {
    if (this.deactivated) {
      this.updateData(true)
    }
  },
  deactivated: function () {
    this.deactivated = true
  },
  beforeDestroy: function () {
    EventBus.$off('update-workday', this.updateData)

    window.removeEventListener('keyup', this.keyupHandler)
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    onNextMonth: function () {
      this.changeMonth(true)
    },
    onPreviousMonth: function () {
      this.changeMonth(false)
    },
    changeMonth: function (next = true) {
      const indexSelectMonth = MONTHS.findIndex(m => m === this.selectMonth)
      if (next) {
        if (indexSelectMonth === MONTHS.length - 1) {
          const indexSelectYear = this.years.findIndex(y => y === this.selectYear)
          this.selectYear = this.years[indexSelectYear + 1]
          this.selectMonth = MONTHS[0]
        } else {
          this.selectMonth = MONTHS[indexSelectMonth + 1]
        }
      } else {
        if (indexSelectMonth === 0) {
          const indexSelectYear = this.years.findIndex(y => y === this.selectYear)
          this.selectYear = this.years[indexSelectYear - 1]
          this.selectMonth = MONTHS[MONTHS.length - 1]
        } else {
          this.selectMonth = MONTHS[indexSelectMonth - 1]
        }
      }
    },
    onStartDrag: function (event) {
      this.moveElementMinIndex = null
      this.moveElementMaxIndex = null

      let i = event.oldIndex
      while (this.rows[i].type !== 'role' && this.rows[i].type !== 'workArea') {
        i--
      }
      this.moveElementMinIndex = i + 1

      i = event.oldIndex
      while (i < this.rows.length && (this.rows[i].type !== 'role' && this.rows[i].type !== 'workArea')) {
        i++
      }
      this.moveElementMaxIndex = i - 1

      this.orderInGroupDefault = []
      for (const workAreaEmployees of this.employeesMap.values()) {
        for (const group of Object.values(workAreaEmployees.groups)) {
          if (group.employees.length) {
            const employees = group.employees

            for (let i = 0; i < employees.length; i++) {
              const employee = employees[i]
              this.orderInGroupDefault.push(employee.orderInGroup)
            }
          }
        }
      }
    },
    onMoveDraggable: function (event) {
      if (event.draggedContext.element.type === 'role' || event.draggedContext.element.type === 'workArea') {
        return false
      }

      if (event.draggedContext.futureIndex < this.moveElementMinIndex || event.draggedContext.futureIndex > this.moveElementMaxIndex) {
        return false
      }
    },
    onEndDrag: function (event) {
      // Пересчитать orderInGroup и orderInGroupIncremental
      for (const workAreaEmployees of this.employeesMap.values()) {
        for (const group of Object.values(workAreaEmployees.groups)) {
          if (group.employees.length) {
            const employees = group.employees

            for (let i = 0; i < employees.length; i++) {
              const employee = employees[i]
              const employeeInRows = this.rows.find((el) => el.id === employee.id && el.groupWorkArea === employee.groupWorkArea && el.role === employee.role)
              const employeeIndexInRows = this.rows.indexOf(employeeInRows)
              if (employeeIndexInRows <= this.moveElementMaxIndex && employeeIndexInRows >= this.moveElementMinIndex) {
                employee.orderInGroupIncremental = employeeIndexInRows - this.moveElementMinIndex + 1
              }
              const employeeIndex = this.rows.filter(el => el.type !== 'role' && el.type !== 'workArea').indexOf(employeeInRows)
              employee.orderInGroup = this.orderInGroupDefault[employeeIndex]
            }
          }
        }
      }
      // Поменять местами согласно новому порядку
      this.sortByOrder()
    },
    setActiveRoles (index) {
      const role = this.roles[index]
      role.active = !role.active

      this.roles.forEach((r) => {
        if (r.key !== role.key) {
          r.active = true
        }
      })

      const selectedRoles = []
      this.roles.forEach((role) => {
        if (role.active) {
          selectedRoles.push(role.key)
        }
      })
      localStorage.setItem('calendarSelectedRoles', selectedRoles)

      this.updateData()
    },
    handleTabClick: function () {
      if (this.tab !== this.lastSelectedTab) {
        this.lastSelectedTab = this.tab
      } else {
        this.lastSelectedTab = null
        this.tab = null
      }
    },
    selectDay: function (dayIndex) {
      const index = this.selectedDays.indexOf(dayIndex)
      if (index !== -1) {
        this.selectedDays.splice(index, 1)
      } else {
        this.selectedDays.push(dayIndex)
      }
    },
    isSelectedDay: function (dayIndex) {
      return this.selectedDays.includes(dayIndex)
    },
    isAnotherMonth: function (dayIndex) {
      if (this.workDays && this.workDays[dayIndex]) {
        const dayMonth = new Date(this.workDays[dayIndex].date).getMonth()
        return dayMonth !== MONTHS.indexOf(this.selectMonth)
      }
    },
    updateEmployees: function (workerIds) {
      this.loading = true

      let url = '/service/delta/workday/get?' + this.getURLSearchParams().toString()

      url += '&id=' + workerIds.toString() + '&shortResult=' + true

      AXIOS.get(url).then(
        (response) => {
          if (response.data) {
            const changedEmployees = response.data.employees
            changedEmployees.forEach((changedEmployee) => {
              const index = this.employeesFromServer.findIndex((employee) => employee.id === changedEmployee.id)
              if (index !== -1) {
                // Перерасчитываем статистику
                if (this.employeesFromServer[index].stat.workTime) {
                  this.commonStatistics.workTime = this.commonStatistics.workTime - this.employeesFromServer[index].stat.workTime
                }
                if (changedEmployee.stat.workTime) {
                  this.commonStatistics.workTime = this.commonStatistics.workTime + changedEmployee.stat.workTime
                }

                if (this.employeesFromServer[index].stat.driverHoursCount) {
                  this.commonStatistics.driverHoursCount = this.commonStatistics.driverHoursCount - this.employeesFromServer[index].stat.driverHoursCount
                }
                if (changedEmployee.stat.driverHoursCount) {
                  this.commonStatistics.driverHoursCount = this.commonStatistics.driverHoursCount + changedEmployee.stat.driverHoursCount
                }

                if (this.employeesFromServer[index].stat.totalReworkTime) {
                  this.commonStatistics.totalReworkTime = this.commonStatistics.totalReworkTime - this.employeesFromServer[index].stat.totalReworkTime
                }
                if (changedEmployee.stat.totalReworkTime) {
                  this.commonStatistics.totalReworkTime = this.commonStatistics.totalReworkTime + changedEmployee.stat.totalReworkTime
                }
                this.employeesFromServer[index] = changedEmployee
              }
            })

            this.setEmployeesMap(JSON.parse(JSON.stringify(this.employeesFromServer)), this.workDays)
              .finally(() => {
                if (this.sortOrderParams.order != null) {
                  this.sortByOrder()
                }
              })
          }
        }
      ).finally(() => {
        this.loading = false
      })
    },
    updateData: function (setXScroll = false, sort, order) {
      const requestId = ++this.workdayRequestId
      this.loading = true
      this.workdaySearchCompleted = false
      this.workdayTimeoutReached = false

      this.scheduleForEdit = []

      let sortColumn = null
      if (sort == null) {
        Object.keys(this.sortOrderParams).forEach(key => {
          if (this.sortOrderParams[key] != null) {
            order = this.sortOrderParams[key]

            if (key !== 'order') {
              sort = key
            } else {
              sort = 'shortFIO'
              sortColumn = 'order'
            }
          }
        })
      }
      const dir = order ? 'ASC' : 'DESC'

      let url = '/service/delta/workday/get?' + this.getURLSearchParams().toString()

      url += '&sort=' + sort + '&dir=' + dir + '&shortResult=' + true
      if (this.isMobile) {
        url += '&filter=workday&formId=mobile'
      }

      AXIOS.get(url, { timeout: 10000 }).then(
        (response) => {
          if (this.workdayRequestId !== requestId || this.workdayTimeoutReached) {
            return
          }
          if (response.data) {
            this.workDays = response.data.workDays
            this.workDays.forEach((workDay) => {
              const utcDate = workDay.date + OFFSET_MSK_MS
              workDay.date = utcDate + new Date().getTimezoneOffset() * 60 * 1000
            })

            this.employeesFromServer = JSON.parse(JSON.stringify(response.data.employees))

            this.commonStatistics = response.data.commonStatistics
            this.overtimeTariffs = response.data.overtimeTariffs && response.data.overtimeTariffs.length ? response.data.overtimeTariffs : []
            this.additionalOvertimeTariffs = response.data.additionalOvertimeTariffs && response.data.additionalOvertimeTariffs.length ? response.data.additionalOvertimeTariffs : []

            this.overtimesGroupByValue = []
            const allTariffs = [...this.overtimeTariffs, ...this.additionalOvertimeTariffs]
            allTariffs.forEach(ot => {
              const index = this.overtimesGroupByValue.findIndex(overtimeGroupByValue => overtimeGroupByValue.value === ot.value)
              if (index === -1) {
                this.overtimesGroupByValue.push({
                  value: ot.value,
                  names: [ot.name],
                  ids: [ot.id]
                })
              } else if (!this.overtimesGroupByValue[index].ids.includes(ot.id)) {
                this.overtimesGroupByValue[index].names.push(ot.name)
                this.overtimesGroupByValue[index].ids.push(ot.id)
              }
            })

            return this.setEmployeesMap(response.data.employees, this.workDays)
              .finally(() => {
                if (sortColumn === 'order') {
                  this.sortByOrder()
                }
              })
          }
        }
      ).catch((error) => {
        if (this.workdayRequestId !== requestId) {
          return
        }

        const errorMessage = String((error && error.message) || '').toLowerCase()
        const isTimeoutError = (error && error.code === 'ECONNABORTED') || errorMessage.includes('timeout')
        if (isTimeoutError) {
          this.workdayTimeoutReached = true
          this.workdaySearchCompleted = true
          this.loading = false
        } else {
          this.workdaySearchCompleted = true
          this.loading = false
        }
      }).finally(() => {
        if (this.workdayRequestId !== requestId) {
          return
        }
        if (this.workdayTimeoutReached) {
          return
        }
        this.workdaySearchCompleted = true
        if (sortColumn === 'order') {
          this.sortByOrder()
        }
        if (setXScroll) {
          this.setXScrollOnCurrentDate()
        }

        this.loading = false
      })
    },
    onSort: function (column) {
      Object.keys(this.sortOrderParams).forEach(key => {
        if (key === column) {
          this.sortOrderParams[key] = !this.sortOrderParams[key]
        } else {
          this.sortOrderParams[key] = null
        }
      })

      if (column === 'order') {
        this.sortByOrder()
      } else {
        this.updateData(false, column, this.sortOrderParams[column])
      }
    },
    sortByOrder: function () {
      for (const workAreaEmployees of this.employeesMap.values()) {
        for (const group of Object.values(workAreaEmployees.groups)) {
          if (group.employees.length) {
            group.employees.sort((a, b) => {
              if (this.sortOrderParams.order) {
                return a.orderInGroup - b.orderInGroup
              } else {
                return b.orderInGroup - a.orderInGroup
              }
            })
          }
        }
      }
      this.rerenderRows()
    },
    rerenderRows: function () {
      this.currentEmployeeIds = []
      if (this.isMobile) {
        let otherBrigadeEmployees = []
        if (this.getBrigade && this.getBrigade.employees) {
          otherBrigadeEmployees = this.getBrigade.employees
            .filter(employee => employee.id !== this.userId)
            .map(employee => employee.id)
        }

        this.currentEmployeeIds = [
          ...otherBrigadeEmployees,
          this.userId
        ]
      }
      this.rows = convertEmployeesFromMapToArray(this.employeesMap, this.workDays, this.currentEmployeeIds)

      // После изменения rows проверить на соответствие selectedRows
      if (this.selectedRows.length) {
        this.selectedRows = this.selectedRows.filter(selectRow =>
          !!this.rows.find(row => {
            const rowKey = row.groupWorkArea + '_' + row.id
            return rowKey === selectRow
          })
        )
      }
    },
    getDayName: function (day) {
      const date = new Date(day.date)

      let dayName = ''
      switch (date.getDay()) {
        case 0:
          dayName = 'Вс.'
          break
        case 1:
          dayName = 'Пн.'
          break
        case 2:
          dayName = 'Вт.'
          break
        case 3:
          dayName = 'Ср.'
          break
        case 4:
          dayName = 'Чт.'
          break
        case 5:
          dayName = 'Пт.'
          break
        case 6:
          dayName = 'Сб.'
          break
      }
      return dayName + date.getDate()
    },
    openEmployeeCard: function (event, employee) {
      event.stopPropagation()
      this.$d_showObjectCard(employee.id, 'employee', event.ctrlKey)
    },
    editDay: function (w, d) {
      if (this.isMobile) {
        return
      }

      const worker = JSON.parse(JSON.stringify(w))
      worker.schedule = [d]
      this.scheduleForEdit = [worker]
      this.scheduleOfWorker = JSON.parse(JSON.stringify(w)).schedule
      this.openedEditSchedule = true
    },
    startSetDays: function (day, w) {
      if (this.isMobile) {
        return
      }

      const worker = JSON.parse(JSON.stringify(w))
      const indexWorker = this.scheduleForEdit.map(worker => worker.id).indexOf(worker.id)

      if (indexWorker !== -1) {
        const schedule = this.scheduleForEdit[indexWorker].schedule
        const indexDay = schedule.indexOf(day)
        if (indexDay !== -1) {
          schedule.splice(indexDay, 1)
          if (schedule.length === 0) {
            this.scheduleForEdit.splice(indexWorker, 1)
          }
        } else {
          this.$set(schedule, schedule.length, day)
        }
      } else {
        worker.schedule = [day]
        this.$set(this.scheduleForEdit, this.scheduleForEdit.length, worker)
      }
    },
    endSetDays: function () {
      this.openedEditSchedule = true
    },
    closedEditSchedule: function () {
      this.openedEditSchedule = false
      this.scheduleForEdit = []
      this.scheduleOfWorker = []
    },
    setXScrollOnCurrentDate: function () {
      const days = 45 * (this.workDays.length || 30)
      const stat = 230

      const calendarTable = document.getElementsByClassName('calendar_table')[0]

      if (calendarTable != null) {
        const maxScrollLeft = calendarTable.scrollWidth - calendarTable.clientWidth
        const ratio = (this.currentDayIndex || 0) * 45 / (days + stat)
        calendarTable.scrollLeft = maxScrollLeft * ratio
      }
    },
    onDisplayFilter: function () {
      this.splitterVerticalModel = 80
    },
    onHideFilter: function () {
      this.splitterVerticalModel = 100
    },
    onSaveOrders: function () {
      this.loading = true
      const bodyFormData = new FormData()

      const orders = {}
      for (const [workArea, workAreaEmployees] of this.employeesMap) {
        const workAreaKey = this.getWorkAreaKeyByName(workArea)
        orders[workAreaKey] = {}

        for (const [role, group] of Object.entries(workAreaEmployees.groups)) {
          if (group.employees.length) {
            orders[workAreaKey][role] = {}

            group.employees.forEach(employee => {
              orders[workAreaKey][role][employee.id] = employee.orderInGroup
            })
          }
        }
      }

      bodyFormData.set('orders', JSON.stringify(orders))
      axiosPost({
        url: '/service/delta/employee/setworkscheduleorder',
        data: bodyFormData,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Сортировка сохранена успешно',
            progress: true,
            timeout: 3000
          })
          this.onCancelEdit()
        },
        onFailure: 'Ошибка сохранения порядка'
      }).finally(() => {
        this.loading = false
      })
    },
    onCancelEdit: function () {
      this.editMode = false
      this.updateData()
    },
    onChangePosition: function (dir) {
      for (const workAreaEmployees of this.employeesMap.values()) {
        for (const group of Object.values(workAreaEmployees.groups)) {
          if (group.employees.length) {
            const employees = group.employees
            if (dir === 'down') {
              let canShift = false
              for (let i = employees.length - 1; i >= 0; i--) {
                const employee = employees[i]
                const employeeKey = employee.groupWorkArea + '_' + employee.id
                if (this.selectedRows.includes(employeeKey) && canShift) {
                  [employees[i], employees[i + 1]] = [employees[i + 1], employees[i]];
                  [employees[i].orderInGroup, employees[i + 1].orderInGroup] = [employees[i + 1].orderInGroup, employees[i].orderInGroup]
                }
                if (!this.selectedRows.includes(employeeKey) && !canShift) {
                  canShift = true
                }
              }
            } else if (dir === 'up') {
              let canShift = false
              for (let i = 0; i < employees.length; i++) {
                const employee = employees[i]
                const employeeKey = employee.groupWorkArea + '_' + employee.id
                if (this.selectedRows.includes(employeeKey) && canShift) {
                  [employees[i], employees[i - 1]] = [employees[i - 1], employees[i]];
                  [employees[i].orderInGroup, employees[i - 1].orderInGroup] = [employees[i - 1].orderInGroup, employees[i].orderInGroup]
                }
                if (!this.selectedRows.includes(employeeKey) && !canShift) {
                  canShift = true
                }
              }
            }
          }
        }
      }
      this.rerenderRows()
    },
    getWorkAreaKeyByName: function (name) {
      let key = null
      this.workAreas.forEach(workArea => {
        if (name === 'КТО ФВФ') {
          key = 'kto'
        } else {
          if (name === workArea.name) {
            key = workArea.key
          }
        }
      })
      return key
    },
    getOvertimeTariffName: function (id) {
      const tariff = [...this.overtimeTariffs, ...this.additionalOvertimeTariffs].find(tariff => tariff.id === id)
      return tariff ? tariff.name : null
    },
    setEmployeesMap: function (employeesFromServer, workDays) {
      let url = '/service/delta/dispatcher/getfilter?type=workday'
      if (this.isMobile) {
        url += '&formId=mobile'
      }
      return AXIOS.get(url).then(
        (response) => {
          let availableWorkAreas = this.selectedWorkAreas
          if (response.data && response.data.workArea && response.data.workArea.selectedValues && response.data.workArea.selectedValues.length) {
            const selectedFilterWorkArea = response.data.workArea.selectedValues
            availableWorkAreas = availableWorkAreas.filter(workArea => selectedFilterWorkArea.includes(workArea.key))
          }
          this.employeesMap = convertEmployeesFromServerToMap(employeesFromServer, workDays, availableWorkAreas)
        }
      )
    },
    onDownload: function () {
      const interval = {}
      interval.start = new Date(this.selectYear, MONTHS.indexOf(this.selectMonth), 1).getTime()
      interval.end = new Date(this.selectYear, MONTHS.indexOf(this.selectMonth) + 1, 1).getTime()

      const sheets = ['workShifts']

      const selectedEmployeeIds = this.selectedRows.map(rowKey => {
        const underscoreIndex = rowKey.indexOf('_')
        if (underscoreIndex === -1) {
          return null
        }
        return rowKey.slice(underscoreIndex + 1)
      })

      this.$d_ask(data => {
        this.loadingFile = true

        const searchParams = this.getURLSearchParams(data.interval, false)
        if (selectedEmployeeIds && selectedEmployeeIds.length) {
          searchParams.set('id', selectedEmployeeIds)
        }
        if (data.sheets && data.sheets.length) {
          searchParams.set('sheets', data.sheets.join(','))
        }

        downloadFile('/service/delta/workday/export?' + searchParams.toString(), () => {
          this.loadingFile = false
        })
      }, 'Интервал выгрузки', {
        interval: { value: interval, type: 'dateinterval', label: 'Интервал', required: true, notIncludeLastDay: true },
        sheets: { value: sheets, type: 'listvalue', label: 'Страницы', required: true, ismultiselect: true, listvalues: [{ key: 'workShifts', name: 'Расписание' }, { key: 'overtimes', name: 'Переработки' }] }
      })
    }
  }
}

